module.exports = __webpack_public_path__ + "static/img/che01.c71399b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che01.png
// module id = IlnU
// module chunks = 1